import WidgetTarget from 'api/dashboard/types/widget/WidgetTarget';
import WidgetType from 'modules/private/dashboard/components/widget-metrics/widgets/WidgetType';

class WidgetPreference {
  position: number;

  type: WidgetType;

  targetData: WidgetTarget | null;

  hasChanges: boolean;

  constructor() {
    this.position = 0;
    this.type = WidgetType.Placeholder;
    this.targetData = null;
    this.hasChanges = false;
  }
}

export default WidgetPreference;
